import { useState } from "react"
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card"
import { Label } from "@/components/ui/label"
import { Input } from "@/components/ui/input"
import { Button } from "@/components/ui/button"
import { requestReset } from "~/apis/passwords"

export default function ForgotPassword() {
  const [ emailAddress, setEmailAddress ] = useState("")
  const [ message, setMessage ] = useState(null)

  async function handleSubmit(event) {
    event.preventDefault()
    const { message } = await requestReset(emailAddress)
    setMessage(message)
  }

  return (
    <div className="mx-auto mt-24 max-w-sm px-6">
      <Card>
        <CardHeader>
          <CardTitle className="text-lg">Forgot your password?</CardTitle>
        </CardHeader>
        <CardContent>
          {message && <p className="mb-4 text-sm text-emerald-600 dark:text-emerald-400">{message}</p>}

          <form onSubmit={handleSubmit} className="space-y-3">
            <div className="space-y-1.5">
              <Label htmlFor="email_address">Email address</Label>
              <Input
                id="email_address"
                type="email"
                required
                autoFocus
                autoComplete="username"
                placeholder="Enter your email address"
                value={emailAddress}
                onChange={(event) => setEmailAddress(event.target.value)}
              />
            </div>
            <Button type="submit" className="w-full">
              Email reset instructions
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  )
}
